import * as types from './types';

export default (state = {
  suggestedTaskNames: { content: [] },
  isSearchingTaskNames: false,
}, action = {}) => {
  switch (action.type) {
    case types.SEARCH_TASK_NAMES_REQUESTED:
      return {
        ...state,
        suggestedTaskNames: { content: [] },
        isSearchingTaskNames: true,
      };
    case types.SEARCH_TASK_NAMES_SUCCESS:
      return {
        ...state,
        isSearchingTaskNames: false,
        suggestedTaskNames: action.suggestions,
      };
    case types.SEARCH_TASK_NAMES_ERROR:
      return {
        ...state,
        isSearchingTaskNames: false,
        suggestedTaskNames: { content: [] },
      };
    default:
      return state;
  }
};
